import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'

export const EndSessionTimerContext = React.createContext()

export const EndSessionTimerProvider = ({children}) => {
    const [showTimer, setShowTimer] = useState(false)
    const [timerValue, setTimerValue] = useState(0)
    const intervalRef = useRef(null)

    const disableTimer = useCallback(() => {
        if (intervalRef.current) clearInterval(intervalRef.current)
        intervalRef.current = null
        setShowTimer(false)
        setTimerValue(0)
    }, [])

    const startTimer = useCallback(ms => {
        if (intervalRef.current) clearInterval(intervalRef.current)
        setTimerValue(Math.max(0, Number(ms) || 0))
        setShowTimer(true)

        intervalRef.current = setInterval(() => setTimerValue(prev => {
            const next = Math.max(0, prev - 1000)
            if (!next && intervalRef.current) {clearInterval(intervalRef.current); intervalRef.current = null}
            return next
        }), 1000)
    }, [])

    useEffect(() => () => {
        if (intervalRef.current) clearInterval(intervalRef.current)
    }, [])

    const Timer = useCallback(() => {
        if (!showTimer) return null
        const seconds = Math.ceil(timerValue / 1000)
        const time = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`

        return <div className="d-flex align-items-center px-2" style={{backgroundColor: '#C5D8FF', borderRadius: 5, fontWeight: 'bold'}}>
            {timerValue > 0 ? `Automatyczne przedłużanie sesji: ${time}` : 'Przedłużanie sesji...'}
        </div>
    }, [showTimer, timerValue])

    const value = useMemo(() => ({StartTimer: startTimer, EndTimer: disableTimer, Timer, TimerIsShow: showTimer}), [startTimer, disableTimer, Timer, showTimer])

    return <EndSessionTimerContext.Provider value={value}>{children}</EndSessionTimerContext.Provider>
}